<template>
  <div v-show="mode == 'cart'" class="w-full h-full">
    <div
      class="absolute top-0 left-0 w-full h-full z-50 bg-white text-center"
      v-show="thanks"
    >
      <img src="/thanks.png" class="w-40 inline-block mt-20" /><br />
      <span class="font-bold text-4xl mt-4 inline-block"
        >Vielen Dank für deinen Einkauf!</span
      >
    </div>
    <div class="w-full top-0 left-0 h-10 bg-gray-200">
      <span class="font-bold text-2xl mt-1 inline-block">Warenkorb</span>
    </div>
    <div class="text-left w-full p-3 relative">
      <div
        v-show="scanError"
        class="absolute top-0 left-0 z-30 center w-full h-full p-10 bg-black/50 text-center"
      >
        <div
          class="bg-white w-2/3 inline-block rounded-3xl overflow-y-auto px-8 py-4 basis-0 relative text-center"
        >
          <span class="font-bold text-2xl inline-block">{{ scanError }}</span>
        </div>
      </div>
      <table class="w-2/3 mt-2 inline-block table-layout-fixed">
        <thead>
          <tr>
            <th class="w-full">Artikel</th>
            <th>Preis</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody class="overflow-y-auto max-h-52 block">
          <tr v-show="cart.length == 0">
            <td colspan="3">Keine Artikel im Warenkorb</td>
          </tr>
          <tr v-for="item in cart" :key="item.name" class="!w-full">
            <td class="w-full">{{ item.name }}</td>
            <td class="whitespace-nowrap">{{ item.amount }} €</td>
            <td class="!text-center">
              <svg
                @click="removeItem(item)"
                xmlns="http://www.w3.org/2000/svg"
                class="w-8 inline-block"
                viewBox="0 0 448 512"
              >
                <!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                <path
                  d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z"
                />
              </svg>
            </td>
          </tr>
        </tbody>
        <tfoot class="w-full">
          <tr class="border-t-2 border-black font-bold">
            <td class="w-full">Summe</td>
            <td colspan="2" class="whitespace-nowrap !text-right">
              {{ sum }} €
            </td>
          </tr>
        </tfoot>
      </table>
      <div
        class="w-1/3 inline-block align-top p-3 text-center"
        v-show="cart.length > 0"
      >
        <button
          @click="mode = 'pay'"
          class="border-black border-2 bg-green-500 rounded-lg px-3 py-2 mt-10 text-white font-bold"
        >
          Jetzt bezahlen
        </button>
        <button
          @click="cart = []"
          class="border-black border-2 bg-red-500 rounded-lg px-3 py-2 mt-20 text-white font-bold"
        >
          Bestellung abbrechen
        </button>
      </div>
    </div>
  </div>
  <div v-show="mode != 'cart'" class="w-full h-full">
    <div class="w-full top-0 left-0 h-10 bg-gray-200">
      <span class="font-bold text-2xl mt-1 inline-block">Kasse</span>
    </div>
    <div v-show="qrValue" class="inline-block">
      <QR
        :value="qrValue"
        :size="250"
        class="inline-block mx-5 mt-3"
        @click="enlargeQR = !enlargeQR"
      ></QR>
    </div>
    <div v-show="cash">
      <span class="inline-block font-bold text-2xl mt-10"
        >Bitte bezahle bar bei bei unserem freundlichen Team</span
      >
    </div>
    <button
      v-show="qrValue || cash"
      class="border-black border-2 bg-red-500 rounded-lg px-3 py-2 mt-10 text-white font-bold inline-block"
      @click="
        qrValue = '';
        cash = false;
      "
    >
      Zurück zur Auswahl
    </button>
    <div v-show="!qrValue && !cash" class="">
      <div
        class="inline-block border-4 border-black rounded-xl w-32 p-2 m-4"
        @click="generateQR('revolut')"
      >
        <img src="/revolut.png" />
      </div>
      <div
        class="inline-block border-4 border-black rounded-xl w-32 p-2 m-4"
        @click="generateQR('paypal')"
      >
        <img src="/paypal.png" />
      </div>
      <div
        class="inline-block border-4 border-black rounded-xl w-32 p-2 m-4"
        @click="generateQR('bank')"
      >
        <img src="/bank.png" />
      </div>
      <div
        class="inline-block border-4 border-black rounded-xl w-32 p-2 m-4"
        @click="cash = true"
      >
        <img src="/bar.png" />
      </div>
    </div>
    <div>
      <button
        v-show="!qrValue && !cash"
        class="border-black border-2 bg-red-500 rounded-lg px-3 py-2 mt-5 text-white font-bold"
        @click="mode = 'cart'"
      >
        Abbrechen
      </button>
    </div>
  </div>
  <div v-if="startManual" class="absolute bottom-10 right-10 z-50">
    <button
      @click="startNFC()"
      class="bg-green-400 rounded-lg px-3 py-2 mt-5 text-whblackite font-bold"
    >
      Start NFC
    </button>
  </div>
</template>

<script>
// @ is an alias to /src
import QR from "@/lib/QR.js";

export default {
  name: "HomeView",
  components: { QR },

  data() {
    return {
      lastmsg: null,
      warehouse: {},
      qrValue: "",
      mode: "cart",
      cash: false,
      thanks: false,
      cart: [],
      webSocket: null,
      showSuccess: false,
      scanError: "",
      showPayment: false,
      startManual: false,
      interval: false,
      isWebSocketAlive: false,
    };
  },
  computed: {
    sum() {
      let sum = 0;
      this.cart.forEach((item) => {
        sum += parseFloat(item.amount.replace(",", "."));
      });
      sum = sum.toFixed(2);
      return ("" + sum).replace(".", ",");
    },
  },
  methods: {
    startNFC() {
      window.rescanner.startNFCScan();
      this.startManual = false;
    },
    generateQR(mode) {
      if (mode == "revolut") {
        this.qrValue = "https://revolut.me/treim";
      } else if (mode == "bank") {
        this.qrValue =
          `BCD
002
1
SCT

Carolin Beckmann
DE05500400000734867500
EUR` +
          this.sum +
          `


Flohmarkt
`;
      } else if (mode == "paypal") {
        this.qrValue = "https://www.paypal.com/qrcodes/p2pqrc/HKN45UYXG92X8";
      }
    },
    removeItem(item) {
      this.cart.splice(this.cart.indexOf(item), 1);
    },
    scanResult(message) {
      message = message
        .trim()
        .replaceAll(" ", "")
        .replaceAll(":", "")
        .toUpperCase();
      if (this.warehouse[message]) {
        // add as first element
        this.playBeep();
        this.cart.unshift(this.warehouse[message]);
      } else {
        this.scanError = "Dieser Code wurde nicht gefunden :/ " + message;
        setTimeout(() => {
          this.scanError = "";
        }, 3000);
      }
    },
    openWebSocket() {
      const url = `wss://s.rescanner.de/ws/shop`;
      if (this.webSocket) {
        this.webSocket.close();
      }
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.webSocket = new WebSocket(url);
      this.isWebSocketAlive = true;
      this.interval = setInterval(() => {
        if (!this.isWebSocketAlive) {
          this.openWebSocket();
        } else if (
          this.websocket &&
          this.websocket.readyState === WebSocket.OPEN
        ) {
          try {
            this.isWebSocketAlive = false;
            fetch("https://s.rescanner.de/shop", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                action: "ping",
              }),
            });
          } catch (error) {
            console.error("Failed to send ping:", error);
            this.openWebSocket();
          }
        } else {
          this.openWebSocket();
        }
      }, 15000);
      this.webSocket.onmessage = (event) => {
        this.isWebSocketAlive = true;
        let data = "";
        try {
          data = JSON.parse(event.data);
          if (data.action == "complete") {
            this.thanks = true;
            this.mode = "cart";
            this.cash = false;
            this.qrValue = false;
            this.cart = [];
            setTimeout(() => {
              this.thanks = false;
            }, 5000);
          } else if (data.action == "add") {
            this.cart.unshift({ name: data.name, amount: "" + data.amount });
          }
        } catch (ignore) {}
      };
    },
    loadRescanner(startNFC = false) {
      let vm = this;
      if (!window.rescanner) {
        let rescannerLib = document.createElement("script");
        rescannerLib.setAttribute("src", "/rescanner.js");
        rescannerLib.onload = () => {
          window.rescanner.onNFCSuccess = (message) => {
            vm.scanResult(message);
          };
          window.rescanner.onQRSuccess = (message) => {
            vm.scanResult(message);
          };
          if (startNFC) window.rescanner.startNFCScan();
        };
        document.head.appendChild(rescannerLib);
      } else {
        window.rescanner.onNFCSuccess = (message) => {
          vm.scanResult(message);
        };
        window.rescanner.onQRSuccess = (message) => {
          vm.scanResult(message);
        };
        if (startNFC) window.rescanner.startNFCScan();
      }
    },
    playBeep(f = 1400) {
      // Create an audio context
      const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      // Create an oscillator
      const oscillator = audioCtx.createOscillator();
      // Set the frequency (in Hz) for the beep
      oscillator.frequency.setValueAtTime(f, audioCtx.currentTime); // A4 note
      oscillator.type = "sine"; // Sound wave type
      // Connect oscillator to destination (speaker)
      oscillator.connect(audioCtx.destination);
      // Play sound
      oscillator.start();
      // Stop sound after 0.2 seconds
      oscillator.stop(audioCtx.currentTime + 0.2);
    },
  },
  async mounted() {
    this.startManual = !window.navigator.userAgent.toLowerCase().includes("wv");
    this.loadRescanner(false);
    this.openWebSocket();
    try {
      const response = await fetch("/data.json");
      this.warehouse = await response.json();
    } catch (error) {
      console.error(error);
    }
    window.vm = this;
  },
};
</script>
<style scoped>
table {
  border-collapse: collapse;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f0f0f0;
}

td {
  background-color: #fff;
}

tr:nth-child(even) {
  background-color: #f9f9f9;
}
</style>